//
// Meter class
//
// Used to show players a visual representation of a meter i.e. credit or winnings
//

MeterManager = {};
MeterManager.meters = [];

MeterManager.createMeter = function (json) {
  if (checkForUndefined(json.initialValue)) {
    json.initialValue = 0;
  }

  var initialValue = Number(json.initialValue);
  if (isNaN(initialValue)) {
    json.initialValue = 0;
    initialValue = 0;
  }

  var meter = new PIXI.Container();
  meter.maxWidth = json.maxWidth;
  meter.Props = {};

  meter._set = function (value) {
    meter.Props.currentValue = value;
    meter.refresh();
  };

  meter.invokeCallback = function () {
    if (meter.Props.callback) {
      // bit odd but there has been a bug where in the handler of the callback the client
      // called countup again and gave it its new callback. But then this got overridden because
      // this function cleared the callback after it invoked it.
      // The fix is to copy the callback here, set the actual callback to undefined and then invoke
      // the callback. This way if the client calls countup again inside this callback handler
      // the callback wont immedately get set to undefined.
      let cb = meter.Props.callback;
      meter.Props.callback = undefined;
      cb();
    }
  };

  meter.set = function (value) {
    // Set() or Add() called from external source cancels counting up
    // This function cancels a count up and sets value to final
    if (meter.Props.isCounting) {
      meter.invokeCallback();
    }
    meter.Props.isCounting = false;
    this._set(value);
  };

  meter.add = function (value) {
    meter.set(meter.Props.currentValue + value);
  };

  meter.refresh = function () {
    this.textObject.setText(gdk.formatCurrency(this.Props.currentValue, meter.Props.formatCurrency));
  };

  meter.countUp = function (valueToAdd, countUpTime, callback) {
    meter.Props.isCounting = true;
    meter.Props.countFrom = meter.Props.currentValue;
    meter.Props.countTo = meter.Props.currentValue + valueToAdd;
    meter.Props.countDelta = valueToAdd;
    meter.Props.totalTime = countUpTime;
    meter.Props.currentTime = countUpTime;
    meter.Props.callback = callback;
  };

  meter.cancelCountUp = function () {
    // This function cancels a count up and sets value to final
    if (meter.Props.isCounting) {
      meter.invokeCallback();
      meter._set(meter.Props.countTo);
      meter.Props.isCounting = false;
    }
  };

  meter.update = function (delta) {
    if (!meter.Props.isCounting) {
      return;
    }

    meter.Props.currentTime -= delta;
    if (meter.Props.currentTime <= 0) {
      meter._set(meter.Props.countTo);
      meter.Props.isCounting = false;
      meter.invokeCallback();
    } else {
      var progress = 1 - meter.Props.currentTime / meter.Props.totalTime;

      const pre = meter.Props.countFrom + meter.Props.countDelta * progress;
      const scaled = pre * 100;
      const floored = Math.floor(scaled);
      const divided = floored / 100;
      meter._set(divided);
    }
  };

  Object.defineProperty(meter, 'value', {
    get: function () {
      return this.Props.currentValue;
    },
  });

  meter.Props.isCounting = false;

  MeterManager.meters.push(meter);
  return meter;
};
MeterManager.destroyMeter = function (meter) {
  var index = MeterManager.meters.indexOf(meter);
  if (index === -1) {
    console.log('Could not destroy meter as it could not be found');
    return;
  }

  MeterManager.meters.splice(index, 1);
};

MeterManager.initialiseMeter = function (json, meter) {
  meter.textObject = resourceManager.createObject('text', 'meterText', json.FQN, {
    anchor: json.anchor,
    fontDefinition: json.fontDefinition,
    fontSize: json.fontSize,
    maxWidth: json.maxWidth,
    maintainAspectRatio: json.maintainAspectRatio,
  });
  meter.Props.formatCurrency = json.formatCurrency ?? true;
  meter.set(Number(json.initialValue));
  meter.Props.currentValue = Number(json.initialValue);

  Reflex.registerEventHandler('layoutChange', MeterManager.onLayoutChange);
};

MeterManager.formatText = function (value) {
  return gdk.formatCurrency(value);
};

MeterManager.update = function (delta) {
  for (var i = 0; i < MeterManager.meters.length; i++) {
    MeterManager.meters[i].update(delta);
  }
};

MeterManager.onLayoutChange = function () {
  for (var i = 0; i < MeterManager.meters.length; i++) {
    MeterManager.meters[i].refresh();
  }
};

Reflex.addToUpdate(MeterManager.update);
resourceManager.registerObjectType(
  'meter',
  MeterManager.createMeter,
  MeterManager.initialiseMeter,
  function () {
    return [];
  },
  MeterManager.destroyMeter
);
